







































































import { Vue, Component } from 'vue-property-decorator'

@Component
export default class OpenWeatherApi extends Vue {
  get codeSnippet1 () {
    return `<html>
  <body>
    <label>City name:</label>
    <input type="text" id="city-name-input" />
    <button id="api-button">Call api</button>
  </body>
</html>`
  }

  get codeSnippet2 () {
    return `  var button = document.getElementById('api-button');
  button.addEventListener('click', callWeatherApi); //Add event listener`
  }

  get codeSnippet3 () {
    return `async function callWeatherApi () {
    const cityNameInput = document.getElementById('city-name-input');
    const cityName = cityNameInput.value;
    return await $.ajax({
      type: "GET",
      url: 'http://api.openweathermap.org/data/2.5/weather?q=' + cityName + '&appid=' + apiKey
    });
  }`
  }

  get codeSnippet4 () {
    return `async function callWeatherApi () {
    const cityNameInput = document.getElementById('city-name-input');
    const cityName = cityNameInput.value;
    const response = await fetch('http://api.openweathermap.org/data/2.5/weather?q=' + cityName + '&appid=' + apiKey);
    return response.json();
  }`
  }

  get codeSnippet5 () {
    return `  async function callWeatherApi () {
    var cityNameInput = document.getElementById('city-name-input');
    var cityName = cityNameInput.value;
    
    const xhr = new XMLHttpRequest();
    xhr.open('GET', 'http://api.openweathermap.org/data/2.5/weather?q=' + cityName + '&appid=' + apiKey);
    xhr.send();
    let weatherData;
    xhr.onload = () => {
      weatherData = xhr.response;
    }
    return weatherData;
  }`
  }
}
